<script setup lang="ts">
    import { ref } from 'vue';
    import { http } from '@/shared/httpWrapper';
    import { useShippingStore } from '@/stores/shippingStore';
    import { shippingPackageSetRemarks } from '@/shared/helpers/api';
    import useShow from '@/shared/composables/useShow';

    const store = useShippingStore();
    const { showError } = useShow();

    const isEditing = ref(false);
    const remarks = ref('');

    function onEdit(): void {
        remarks.value = store.selectedPackage!.remarks || '';
        isEditing.value = true;
    }

    async function onSave(): Promise<void> {
        try {
            if (!store.selectedPackage) {
                throw new Error('No package selected');
            }
            await shippingPackageSetRemarks(http, store.selectedPackage.packageId, remarks.value);
            store.selectedPackage.remarks = remarks.value;
        } catch {
            showError('Saving remarks failed!');
        } finally {
            isEditing.value = false;
        }
    }

    function onCancel(): void {
        isEditing.value = false;
    }

</script>

<template>
    <div v-if="isEditing">
        <div class="buttons mb-0 mt-2 is-flex is-justify-content-flex-end">
            <b-button
                size="is-small"
                icon-left="close"
                @click="onCancel">
                Cancel
            </b-button>
            <b-button
                size="is-small"
                type="is-primary"
                icon-left="floppy"
                @click="onSave">
                Save
            </b-button>
        </div>
        <b-input
            v-model="remarks"
            type="textarea"
            maxlength="2024"
            placeholder="Remarks..."
            class="pb-1" />
    </div>
    <div
        v-else
        class="is-flex p-2">
        <div style="flex-grow: 1;">
            {{ store.selectedPackage?.remarks || 'no remarks' }}
        </div>
        <b-button
            size="is-small"
            icon-left="pencil"
            @click="onEdit">
            Edit
        </b-button>
    </div>
</template>
